/**
 {
    name: 'Dashboard',
    icon: 'mdi-mdi-view-dashboard',
    to: 'dashboard',
    href: '#',
    children: [
      {
        name: 'Menu 1',
        to: 'dashboard',
        href: '#',
        fresh: true
      }
    ]
  }
*/

export default [
  {
    heading: 'Admin',
    roles: ['admin']
  },
  {
    name: 'Project evaluation',
    icon: 'mdi-star-cog-outline',
    to: 'project-evaluations.index',
    roles: ['admin']
  },
  {
    name: 'Reports',
    icon: 'mdi-chart-timeline',
    to: 'reports',
    roles: ['admin'],
    children: [
      {
        name: 'Tasks',
        to: 'reports.tasks',
        fresh: true,
        roles: ['admin']
      },
      {
        name: 'Task records',
        to: 'reports.task-records',
        fresh: true,
        roles: ['admin']
      },
      {
        name: 'Points',
        to: 'reports.points',
        fresh: true,
        roles: ['admin']
      }
    ]
  },
  {
    name: 'Users',
    icon: 'mdi-account-supervisor-outline',
    to: 'users',
    roles: ['admin']
  },
  {
    name: 'Feedback',
    icon: 'mdi-message-alert-outline',
    to: 'feedback',
    roles: ['admin']
  }
]
